import React from 'react'

export interface OnTrueProps
{
    test: boolean;
    children?: JSX.Element | JSX.Element[] | (() => JSX.Element) | (() => JSX.Element[]);
}
const OnTrue = ({ test, children = null }: OnTrueProps) => {
    let fetcher =  children instanceof Function ? (children as Function) : (() => children);
    if (test)
        return <>{fetcher()}</>;
    else
        return null;
}

export default OnTrue;